import {CompensationInputModel} from "./compensation.input-model";
import {CompensationDateInputModel} from "./compensation-date.input-model";

export class CompensationPackedInputModel{
  compensationCalculationInputModel : CompensationInputModel[]
  compensationDateInputModel: CompensationDateInputModel
}
